import { css } from '@emotion/react';
import styled from '@emotion/styled';
import MUIBox from '@mui/material/Box';

import {
  black60,
  dustyOrangeTwo,
  sizeMobile,
  sizeTablet,
  sizeTabletLg,
  standardBorder,
  standardPaddingMobileMd,
  turquoise,
  typeAboutCourseDescription,
  typeFeaturedTeacherName,
  typeLearnArticleQuote,
} from '~/styles';

export const CardMedia = styled(MUIBox)`
  border-radius: 50%;
  width: 150px;
  height: 150px;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  object-fit: cover;
  ${sizeMobile(css`
    width: 100px;
    height: 100px;
  `)}
`;
// Unable to style many of children directly,
// some of these are fed from EE.
export const ImageCard = styled.img``;
export const ImageWrapper = styled.div`
  // display: flex;
  // justify-content: center;
`;

// ygi-about-course
export const AboutCourseMain = styled.section`
  padding: 0;

  h1 {
    font-size: 17px;
    line-height: 24px;
    letter-spacing: 0.15px;
    text-align: center;
    font-weight: 600;
    color: ${dustyOrangeTwo};
    margin: 36px 0 12px;
  }

  h2 {
    margin: 10px 0 20px 0;
    color: ${turquoise};
    font-size: 1.2rem;
    letter-spacing: 2pt;
    text-transform: uppercase;
    font-weight: 600;
  }

  h3 {
    ${typeFeaturedTeacherName};
    color: ${black60};
    font-size: 16px;
    margin: 36px 0 12px;
  }

  h4 {
    color: ${black60};
    font-size: 20px;
    margin: 36px 0 12px;
  }
  img {
    max-width: 100%;
    margin-bottom: 20px;
  }

  p {
    ${typeAboutCourseDescription};
    width: 100%;
    padding: 5px 0;
    letter-spacing: 0.5px;
    font-weight: 400;
  }

  ul {
    ${typeAboutCourseDescription};
  }

  a {
    text-decoration: none;
    :hover,
    :focus {
      text-decoration: underline;
    }
  }

  blockquote p {
    ${typeLearnArticleQuote};
    padding: 30px 50px;
  }

  .ygi-about-course-certification-section {
    display: flex;
  }

  .ygi-about-course-certification-badges {
    margin-right: 40px;
  }

  .ygi-about-course-certification-description-wrapper {
    margin-top: 20px;
  }

  .ygi-about-course-certification-badge {
    border-radius: 50%;
    margin: 18px 0;
  }

  .ygi-about-course-teachers {
    margin: 0 194px;
    border-top: ${standardBorder};
  }

  ${sizeTablet(css`
    .ygi-about-course-wrapper {
      padding: 0 ${standardPaddingMobileMd};
    }

    .ygi-about-course-certification-section {
      flex-direction: column;
    }

    .ygi-about-course-certification-badges {
      display: flex;
      justify-content: space-around;
      margin: 0;
    }

    .ygi-about-course-certification-badge {
      width: 74px;
      height: 74px;
    }

    .ygi-about-course-teachers {
      margin: 0;
      border: none;
      padding: ${standardPaddingMobileMd};

      .ygi-author-bio {
        margin: 0;
      }

      .ygi-author-bio__info {
        padding-left: 20px;
      }

      .ygi-author-bio__follow-button {
        left: 140px;
        top: 60px;
      }
    }
  `)}
`;

// ygi-about-course__wrapper
export const AboutCourseWrapper = styled.div`
  padding: 0;
  ${sizeTabletLg(css`
    padding: 0;
  `)};
`;
